module.exports = __webpack_public_path__ + "static/media/dinosaur(21).b8e771ec.PNG";